import { v1 } from "../api";

// empresas
export async function getEmpresas({ params = {} }) {
  const response = await v1.get("empresas", { params });

  return response.data;
}

export async function addEmpresa({ empresa = {}, archivos = {} }) {
  const formData = new FormData();

  formData.append("empresa", JSON.stringify(empresa));

  for (const archivo of [...archivos]) {
    formData.append(archivo.name, archivo);
  }

  const response = await v1.post(`empresas`, formData, {
    responseType: "blob",
    headers: {
      "Content-Type": "multipart/form-data",
      Accept: "application/pdf",
    },
  });

  return response;
}

export async function getEmpresa({ empresaId = 0 }) {
  const response = await v1.get(`empresas/${empresaId}`);

  return response.data;
}

export async function updateEmpresa({ empresaId = 0, empresa = {} }) {
  const {
    empresa_id,
    registro_ccia_fecha,
    registro_ccia_folio,
    registro_ccia_tomo,
    registro_ccia_pago_por_inscripcion,
    registro_ccia_multa,
    empresa_reinscripcion_fecha,
    establecimientos,
    telefonos,
    celulares,
    correos_electronicos,
    paginas_web,
    encargados,
    actividades_economicas,
    importaciones,
    exportaciones,
    empresa_cerrada,
    empresa_reinscrita,
    ...rest
  } = empresa;

  const response = await v1.put(`empresas/${empresaId}`, rest);

  return response;
}

export async function deleteEmpresa({ empresaId = 0 }) {
  const response = await v1.delete(`empresas/${empresaId}`);

  return response.data;
}

// establecimientos por empresa
export async function getEstablecimientos({ empresaId = 0, params = {} }) {
  const response = await v1.get(`empresas/${empresaId}/establecimientos`, {
    params,
  });

  return response.data;
}

export async function addEstablecimiento({
  empresaId = 0,
  establecimiento = {},
}) {
  const response = await v1.post(
    `empresas/${empresaId}/establecimientos`,
    establecimiento
  );

  return response;
}

export async function getEstablecimiento({
  empresaId = 0,
  establecimientoId = 0,
}) {
  const response = await v1.get(
    `empresas/${empresaId}/establecimientos/${establecimientoId}`
  );

  return response.data;
}

export async function updateEstablecimiento({
  empresaId = 0,
  establecimientoId = 0,
  establecimiento = {},
}) {
  const response = await v1.put(
    `empresas/${empresaId}/establecimientos/${establecimientoId}`,
    establecimiento
  );

  return response;
}

export async function deleteEstablecimiento({
  empresaId = 0,
  establecimientoId = 0,
}) {
  const response = await v1.delete(
    `empresas/${empresaId}/establecimientos/${establecimientoId}`
  );

  return response;
}

export async function verifyEstablecimiento({
  empresaId = 0,
  establecimientoId = 0,
  establecimiento_verificado = false,
}) {
  const response = await v1.patch(
    `empresas/${empresaId}/establecimientos/${establecimientoId}/verify`,
    {
      establecimiento_verificado,
    }
  );

  return response;
}

// telefonos por empresa
export async function getTelefonos({ empresaId = 0, params = {} }) {
  const response = await v1.get(`empresas/${empresaId}/telefonos`, {
    params,
  });

  return response.data;
}

export async function addTelefono({ empresaId = 0, telefono = {} }) {
  const response = await v1.post(`empresas/${empresaId}/telefonos`, telefono);

  return response;
}

export async function getTelefono({ empresaId = 0, telefonoId = 0 }) {
  const response = await v1.get(
    `empresas/${empresaId}/telefonos/${telefonoId}`
  );

  return response.data;
}

export async function updateTelefono({
  empresaId = 0,
  telefonoId = 0,
  telefono = {},
}) {
  const response = await v1.put(
    `empresas/${empresaId}/telefonos/${telefonoId}`,
    telefono
  );

  return response;
}

export async function deleteTelefono({ empresaId = 0, telefonoId = 0 }) {
  const response = await v1.delete(
    `empresas/${empresaId}/telefonos/${telefonoId}`
  );

  return response;
}

export async function verifyTelefono({ empresaId = 0, telefonoId = 0 }) {
  const response = await v1.patch(
    `empresas/${empresaId}/telefonos/${telefonoId}/verify`
  );

  return response;
}

// celulares por empresa
export async function getCelulares({ empresaId = 0, params = {} }) {
  const response = await v1.get(`empresas/${empresaId}/celulares`, {
    params,
  });

  return response.data;
}

export async function addCelular({ empresaId = 0, celular = {} }) {
  const response = await v1.post(`empresas/${empresaId}/celulares`, celular);

  return response;
}

export async function getCelular({ empresaId = 0, celularId = 0 }) {
  const response = await v1.get(`empresas/${empresaId}/celulares/${celularId}`);

  return response.data;
}

export async function updateCelular({
  empresaId = 0,
  celularId = 0,
  celular = {},
}) {
  const response = await v1.put(
    `empresas/${empresaId}/celulares/${celularId}`,
    celular
  );

  return response;
}

export async function deleteCelular({ empresaId = 0, celularId = 0 }) {
  const response = await v1.delete(
    `empresas/${empresaId}/celulares/${celularId}`
  );

  return response;
}

export async function verifyCelular({ empresaId = 0, celularId = 0 }) {
  const response = await v1.patch(
    `empresas/${empresaId}/celulares/${celularId}/verify`
  );

  return response;
}

// correos electrónicos por empresa
export async function getCorreosElectronicos({ empresaId = 0, params = {} }) {
  const response = await v1.get(`empresas/${empresaId}/correos-electronicos`, {
    params,
  });

  return response.data;
}

export async function addCorreoElectronico({
  empresaId = 0,
  correoElectronico = {},
}) {
  const response = await v1.post(
    `empresas/${empresaId}/correos-electronicos`,
    correoElectronico
  );

  return response;
}

export async function getCorreoElectronico({
  empresaId = 0,
  correoElectronicoId = 0,
}) {
  const response = await v1.get(
    `empresas/${empresaId}/correos-electronicos/${correoElectronicoId}`
  );

  return response.data;
}

export async function updateCorreoElectronico({
  empresaId = 0,
  correoElectronicoId = 0,
  correoElectronico = {},
}) {
  const response = await v1.put(
    `empresas/${empresaId}/correos-electronicos/${correoElectronicoId}`,
    correoElectronico
  );

  return response;
}

export async function deleteCorreoElectronico({
  empresaId = 0,
  correoElectronicoId = 0,
}) {
  const response = await v1.delete(
    `empresas/${empresaId}/correos-electronicos/${correoElectronicoId}`
  );

  return response;
}

export async function verifyCorreoElectronico({
  empresaId = 0,
  correoElectronicoId = 0,
}) {
  const response = await v1.patch(
    `empresas/${empresaId}/correos-electronicos/${correoElectronicoId}/verify`
  );

  return response;
}

// páginas web por empresa
export async function getPaginasWeb({ empresaId = 0, params = {} }) {
  const response = await v1.get(`empresas/${empresaId}/paginas-web`, {
    params,
  });

  return response.data;
}

export async function addPaginaWeb({ empresaId = 0, paginaWeb = {} }) {
  const response = await v1.post(
    `empresas/${empresaId}/paginas-web`,
    paginaWeb
  );

  return response;
}

export async function getPaginaWeb({ empresaId = 0, paginaWebId = 0 }) {
  const response = await v1.get(
    `empresas/${empresaId}/paginas-web/${paginaWebId}`
  );

  return response.data;
}

export async function updatePaginaWeb({
  empresaId = 0,
  paginaWebId = 0,
  paginaWeb = {},
}) {
  const response = await v1.put(
    `empresas/${empresaId}/paginas-web/${paginaWebId}`,
    paginaWeb
  );

  return response;
}

export async function deletePaginaWeb({ empresaId = 0, paginaWebId = 0 }) {
  const response = await v1.delete(
    `empresas/${empresaId}/paginas-web/${paginaWebId}`
  );

  return response;
}

export async function verifyPaginaWeb({ empresaId = 0, paginaWebId = 0 }) {
  const response = await v1.patch(
    `empresas/${empresaId}/paginas-web/${paginaWebId}/verify`
  );

  return response;
}

// encargados por empresa
export async function getEncargados({ empresaId = 0, params = {} }) {
  const response = await v1.get(`empresas/${empresaId}/encargados`, {
    params,
  });

  return response.data;
}

export async function addEncargado({ empresaId = 0, encargado = {} }) {
  const response = await v1.post(`empresas/${empresaId}/encargados`, encargado);

  return response;
}

export async function getEncargado({ empresaId = 0, encargadoId = 0 }) {
  const response = await v1.get(
    `empresas/${empresaId}/encargados/${encargadoId}`
  );

  return response.data;
}

export async function updateEncargado({
  empresaId = 0,
  encargadoId = 0,
  encargado = {},
}) {
  const response = await v1.put(
    `empresas/${empresaId}/encargados/${encargadoId}`,
    encargado
  );

  return response;
}

export async function deleteEncargado({ empresaId = 0, encargadoId = 0 }) {
  const response = await v1.delete(
    `empresas/${empresaId}/encargados/${encargadoId}`
  );

  return response;
}

export async function verifyEncargado({ empresaId = 0, encargadoId = 0 }) {
  const response = await v1.patch(
    `empresas/${empresaId}/encargados/${encargadoId}/verify`
  );

  return response;
}

// actividades económicas por empresa
export async function getActividadesEconomicas({ empresaId = 0, params = {} }) {
  const response = await v1.get(
    `empresas/${empresaId}/actividades-economicas`,
    {
      params,
    }
  );

  return response.data;
}

export async function addActividadEconomica({
  empresaId = 0,
  actividadEconomica = {},
}) {
  const response = await v1.post(
    `empresas/${empresaId}/actividades-economicas`,
    actividadEconomica
  );

  return response;
}

export async function getActividadEconomica({
  empresaId = 0,
  actividadId = 0,
}) {
  const response = await v1.get(
    `empresas/${empresaId}/actividades-economicas/${actividadId}`
  );

  return response.data;
}

export async function updateActividadEconomica({
  empresaId = 0,
  actividadId = 0,
  actividadEconomica = {},
}) {
  const response = await v1.put(
    `empresas/${empresaId}/actividades-economicas/${actividadId}`,
    actividadEconomica
  );

  return response;
}

export async function deleteActividadEconomica({
  empresaId = 0,
  actividadId = 0,
}) {
  const response = await v1.delete(
    `empresas/${empresaId}/actividades-economicas/${actividadId}`
  );

  return response;
}

export async function verifyActividadEconomica({
  empresaId = 0,
  actividadId = 0,
}) {
  const response = await v1.patch(
    `empresas/${empresaId}/actividades-economicas/${actividadId}/verify`
  );

  return response;
}

// importaciones por empresa
export async function getImportaciones({ empresaId = 0, params = {} }) {
  const response = await v1.get(`empresas/${empresaId}/importaciones`, {
    params,
  });

  return response.data;
}

export async function addImportacion({ empresaId = 0, importacion = {} }) {
  const response = await v1.post(
    `empresas/${empresaId}/importaciones`,
    importacion
  );

  return response;
}

export async function getImportacion({ empresaId = 0, importacionId = 0 }) {
  const response = await v1.get(
    `empresas/${empresaId}/importaciones/${importacionId}`
  );

  return response.data;
}

export async function updateImportacion({
  empresaId = 0,
  importacionId = 0,
  importacion = {},
}) {
  const response = await v1.put(
    `empresas/${empresaId}/importaciones/${importacionId}`,
    importacion
  );

  return response;
}

export async function deleteImportacion({ empresaId = 0, importacionId = 0 }) {
  const response = await v1.delete(
    `empresas/${empresaId}/importaciones/${importacionId}`
  );

  return response;
}

export async function verifyImportacion({ empresaId = 0, importacionId = 0 }) {
  const response = await v1.patch(
    `empresas/${empresaId}/importaciones/${importacionId}/verify`
  );

  return response;
}

// exportaciones por empresa
export async function getExportaciones({ empresaId = 0, params = {} }) {
  const response = await v1.get(`empresas/${empresaId}/exportaciones`, {
    params,
  });

  return response.data;
}

export async function addExportacion({ empresaId = 0, exportacion = {} }) {
  const response = await v1.post(
    `empresas/${empresaId}/exportaciones`,
    exportacion
  );

  return response;
}

export async function getExportacion({ empresaId = 0, exportacionId = 0 }) {
  const response = await v1.get(
    `empresas/${empresaId}/exportaciones/${exportacionId}`
  );

  return response.data;
}

export async function updateExportacion({
  empresaId = 0,
  exportacionId = 0,
  exportacion = {},
}) {
  const response = await v1.put(
    `empresas/${empresaId}/exportaciones/${exportacionId}`,
    exportacion
  );

  return response;
}

export async function deleteExportacion({ empresaId = 0, exportacionId = 0 }) {
  const response = await v1.delete(
    `empresas/${empresaId}/exportaciones/${exportacionId}`
  );

  return response;
}

export async function verifyExportacion({ empresaId = 0, exportacionId = 0 }) {
  const response = await v1.patch(
    `empresas/${empresaId}/exportaciones/${exportacionId}/verify`
  );

  return response;
}

// archivos por empresa
export async function getArchivos({ empresaId = 0, params = {} }) {
  const response = await v1.get(`empresas/${empresaId}/archivos`, {
    params,
  });

  return response.data;
}

export async function addArchivos({ empresaId = 0, archivos = {} }) {
  const formData = new FormData();

  for (const archivo of [...archivos]) {
    formData.append(archivo.name, archivo);
  }

  const response = await v1.post(`empresas/${empresaId}/archivos`, formData, {
    headers: {
      "Content-Type": "multipart/form-data",
    },
  });

  return response;
}

export async function deleteArchivo({ empresaId = 0, filename = "" }) {
  const response = await v1.delete(
    `empresas/${empresaId}/archivos/${filename}`
  );

  return response;
}

// formatos
export async function getFormatos({ empresaId = 0, params = {} }) {
  const response = await v1.get(`empresas/${empresaId}/formatos`, {
    params,
  });

  return response.data;
}

export async function getInscripcion({ empresaId = 0, params = {} }) {
  const response = await v1.get(
    `empresas/${empresaId}/formatos/hoja-de-inscripcion`,
    {
      params,
      responseType: "blob",
      headers: {
        "Content-Type": "multipart/form-data",
        Accept: "application/pdf",
      },
    }
  );

  return response.data;
}

export async function getDiplomaInscripcion({ empresaId = 0, params = {} }) {
  const response = await v1.get(
    `empresas/${empresaId}/formatos/diploma-de-inscripcion`,
    {
      params,
      responseType: "blob",
      headers: {
        "Content-Type": "multipart/form-data",
        Accept: "application/pdf",
      },
    }
  );

  return response;
}
